export const TEETH = {
    tpUpper: {
        ant: [[13, 12, 11], [21, 22, 23]],
        post: [[18, 17, 16, 15, 14], [24, 25, 26, 27, 28]]
    },
    tpLower: {
        ant: [[43, 42, 41], [31, 32, 33]],
        post: [[48, 47, 46, 45, 44], [34, 35, 36, 37, 38]]
    }
}

export const getTpJaw = type => ({
    name: 'tp' + type.charAt(0).toUpperCase() + type.slice(1),
    TRANS: type === 'upper' ? 'SPE_MAXI' : 'SPE_MAND'
})

export const jawTypes = content => {
    if (content === 'upper') return ['upper']
    if (content === 'lower') return ['lower']
    return ['upper', 'lower']
}

export const mergeJawTypes = (att, ipr) => {
    const raw = [...new Set([...att, ...ipr])]
    const expanded = raw.flatMap(j => j === 'both' ? ['upper', 'lower'] : [j])
    return [...new Set(expanded)]
}

export const formatKeyframe = keyframe =>
    keyframe.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
